module.exports = __webpack_public_path__ + "img/Billing.c38cfa82.svg";